export default __webpack_public_path__ + "static/media/FoxFm.7ad59065.png";